import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { ToolbarButtonComponent } from './toolbar-button/toolbar-button.component';
import { TooltipModule } from 'primeng/tooltip';
import { FitType } from '../model/fit-type.enum';
import { TooltipDirective } from '@vydaps/gui-commons';
import { DocumentSearchPopoverComponent } from '../document-search-popover/document-search-popover.component';
import { PSDocumentPage } from '../model/document-page.interface';
import { SearchQuery } from '../model/document-searcher.interface';
import { FloatingElementDirective, ToastService } from '@ps-gui/shared-core';

@Component({
  selector: 'shared-dp-preview-tool-bar',
  imports: [
    ToolbarButtonComponent,
    TooltipModule,
    TooltipDirective,
    DocumentSearchPopoverComponent,
    FloatingElementDirective,
  ],
  templateUrl: './preview-tool-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewToolBarComponent {
  readonly currentPageIndex = input.required<number | undefined>();
  readonly totalPageCount = input.required<number>();
  readonly currentPage = input.required<PSDocumentPage>();
  readonly fitType = input.required<FitType>();
  readonly foundWordsCount = input.required<number | undefined>();

  readonly toggleFitType = output();
  readonly zoomChange = output<number>();
  readonly searchQueried = output<SearchQuery>();
  readonly searchClear = output();

  private readonly toastService = inject(ToastService);

  protected onRotateClicked() {
    this.toastService.addErrorToast(
      `Funktion zurzeit nicht verfügbar. Bitte Seiten-ID an Julian weitergeben: ${this.currentPage().id}`,
    );
  }
  readonly zoomStep: number = 0.3;
}
